// extracted by mini-css-extract-plugin
export default {"container":"Tp8rRTF_3eaR_yyfGEV7"};